import { RFITracker } from '../../../cimsPage/instances/rfi'
import { BasicPermissionItem } from '../../PermissionItem'
import {
  CreateViewEditSoftRemoveRestore,
  Revert,
  Simple,
  Unlock,
} from '../../common'

const page = RFITracker
const object = 'Request For Information'
const plural = 'requests for information'

const rfi = CreateViewEditSoftRemoveRestore({
  page,
  object,
  plural,
  create: '2aacc6fa-1a07-4bc1-9a3c-1db93b1ba196',
  view: '6ce931ff-b82c-4f79-864e-167d9f383efc',
  edit: '2e62c4f9-f030-4830-8fd3-2b29ff7c9b13',
  removeRestore: 'ae5ae1c3-d9c8-41c3-9ae1-fc5989af1bee',
})

export const CreateRequestForInformation = rfi.Create
export const ViewRequestForInformation = rfi.View
export const EditRequestForInformation = rfi.Edit
export const RemoveRestoreRequestForInformation = rfi.RemoveRestore

export const CommentOnRequestForInformation = Simple({
  id: 'df0bef36-e5f3-439e-acf7-756437482c24',
  action: 'Comment on',
  page,
  object,
  plural,
})

export const RespondAllRFIResponseDisciplines = new BasicPermissionItem({
  id: '4457fce3-e48b-4ace-807f-228a27f56611',
  name: `Respond All Response Disciplines`,
  action: 'respond to all response disciplines',
  page,
  allowMixedCase: true,
})

export const RevertRequestForInformation = Revert({
  id: '237a9ccc-e3bb-46a6-adc4-e8b96f3a57c5',
  page,
  object,
  plural,
})

export const UnlockRequestForInformation = Unlock({
  id: 'a7718bec-a285-4a45-8fed-72d55545c539',
  page,
  object,
  plural,
})

export type RFITrackerPermission =
  | typeof CreateRequestForInformation
  | typeof ViewRequestForInformation
  | typeof EditRequestForInformation
  | typeof RemoveRestoreRequestForInformation
  | typeof CommentOnRequestForInformation
  | typeof RespondAllRFIResponseDisciplines
  | typeof RevertRequestForInformation
  | typeof UnlockRequestForInformation
